import type { ListFieldProps } from '../../form-hooks/fields/ListField/ListField';

import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../lib/helpers';

import ListField from '../../form-hooks/fields/ListField/ListField';

export interface SlugSettingsModalContentProps extends Pick<
  ListFieldProps,
  'disabled' | 'testId'
> {
  /**
   * Available property names for source/target selects
   */
  propertyNames: string[];
}

const SlugSettingsModalContent = ({
  propertyNames,
  disabled,
  testId = '',
}: SlugSettingsModalContentProps) => {
  const { t } = useTranslation();

  // ListField config for a single SlugRule of the CTD.
  return (
    <ListField
      itemAdditionalClasses="space-y-4"
      label={'Slug'}
      itemsProps={{
        order: ['active', 'source', 'target'],
        propertiesConfig: {
          active: {
            inputType: 'checkbox',
            label: t('ContentTypeForm.SlugsSettingsModal.Active'),
          },
          source: {
            inputType: 'select',
            label: t('ContentTypeForm.SlugsSettingsModal.Source'),
            options: propertyNames,
            helpText: t('ContentTypeForm.SlugsSettingsModal.SourceHelpText'),
          },
          target: {
            inputType: 'select',
            label: t('ContentTypeForm.SlugsSettingsModal.Target'),
            options: propertyNames,
            helpText: t('ContentTypeForm.SlugsSettingsModal.TargetHelpText'),
          },
        },
      }}
      itemsSchema={{
        type: 'object',
        properties: {
          source: { type: 'string' },
          target: { type: 'string' },
          active: { type: 'boolean', default: true },
        },
        required: ['source', 'target'],
      }}
      disabled={disabled}
      {...getTestProps(testId, 'slug-settings', 'testId')}
    />
  );
};

export default SlugSettingsModalContent;
